if (!window.dbmLanguageToggleInitialized) {
  window.dbmLanguageToggleInitialized = true;

  document.addEventListener('click', (event) => {
    const option = event.target.closest('.language-selector-toggle__option');
    if (!option || option.classList.contains('is-active')) return;

    const form = option.closest('form');
    const input = form && form.querySelector('input[name="locale_code"]');
    if (!input) return;

    input.value = option.dataset.value;
    form.submit();
  });
}
